[
  {
    "name": "가을학기 정규반",
    "href": "/courses/fall"
  },
  {
    "name": "여름방학 특강",
    "href": "/courses/summer",
    "hide": true
  },
  {
    "name": "2026 여름/가을 대회 트랙",
    "href": "/courses/competitions-2026"
  },
  {
    "name": "겨울방학 특강",
    "href": "/courses/winterbreak",
    "hide": true
  },
  {
    "name": "가을학기 정규반",
    "href": "/courses/fall",
    "hide": true
  },
  {
    "name": "초등부 대회",
    "href": "/courses/competitions-jr"
  },
  {
    "name": "중·고등부 대회",
    "href": "/courses/competitions-sr"
  }
]
